// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorExternalResourceEditTemplate_heading__2Uui1","buttonLink":"LandscapeIndicatorExternalResourceEditTemplate_buttonLink__T2R0v"};